// assets
import { DashboardOutlined, FileTextOutlined, AuditOutlined, HistoryOutlined, TeamOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  FileTextOutlined,
  AuditOutlined,
  HistoryOutlined,
  TeamOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'userreport',
      title: 'Old User Report',
      type: 'item',
      url: '/userreport',
      icon: icons.FileTextOutlined,
      permissionKey: 'oldUserReport'
    },
    {
      id: 'usernewreport',
      title: 'New User Report',
      type: 'item',
      url: '/usernewreport',
      icon: icons.AuditOutlined,
      permissionKey: 'newUserReport'
    },

    // {
    //   id: 'overallusers',
    //   title: 'Over All Users Report',
    //   type: 'item',
    //   url: '/Overallusers',
    //   icon: icons.TeamOutlined,
    //   permissionKey: 'overallUsersReport'
    // },
    {
      id: 'maturity',
      title: 'Over All Maturity',
      type: 'collapse',
      icon: icons.AuditOutlined,
      permissionKey: 'newUserReport',
      children: [
        {
          id: 'maturity-report',
          title: 'Maturity',
          type: 'item',
          url: '/maturity',
          icon: icons.AuditOutlined,
          permissionKey: 'newUserReport'
        },
        {
          id: 'maturity-report',
          title: 'filter Maturity',
          type: 'item',
          url: '/email_Maturity',
          icon: icons.AuditOutlined,
          permissionKey: 'newUserReport'
        }
      ]
    },

    {
      id: 'oldusers',
      title: 'Old Users list',
      type: 'item',
      url: '/oldusers',
      icon: icons.HistoryOutlined,
      permissionKey: 'oldUsersList'
    }
  ]
};

export default dashboard;
